export default {
  namespaced: true,

  state: {
    homeData: {}
  },
  getters: {
    getFirst(state) {
      return state.homeData ? state.homeData.first : null;
    },
    getSecond(state) {
      return state.homeData ? state.homeData.second : null;
    },
    getThird(state) {
      return state.homeData ? state.homeData.third : null;
    },
    getFourth(state) {
      return state.homeData ? state.homeData.fourth : null;
    }
  },
  actions: {
    async loginOut(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/user/loginOut",
        data
      );
    },
    async indexHome(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/menu/loadViewData",
        data
      );
      commit("setHomeData", res.data.data);
    }
  },

  mutations: {
    setHomeData(state, data) {
      state.homeData = data;
    }
  }
};
